export default __webpack_public_path__ + "static/media/icon_data_opt_out_btn.2e89654e.svg";